import { useState } from "react";
import { Button, BUTTON_VARIANT } from "components/UI/Button";
import { AngleDown } from "components/UI/Icons";
import { LENGTH_UNIT_OPTIONS, WEIGHT_UNIT_OPTIONS } from "constants/units.contants";
import { useAppSelector } from "hooks/useAppSelector";
import { selectOptions } from "store";
import { UNITS } from "./UnitsDropdown.types";
import { UnitsSettingsModal } from "./UnitsSettingsModal";
import s from "./UnitsDropdown.module.scss";

const buttonLabel = (lengthUnits: string, weightUnits: string) => {
  if (lengthUnits === "mm" && weightUnits === "kg") return UNITS.SI;
  if (lengthUnits === "inch" && weightUnits === "lb") return UNITS.US;

  const lengthLabel = LENGTH_UNIT_OPTIONS.find((option) => option.value === lengthUnits)?.label ?? lengthUnits;
  const weightLabel = WEIGHT_UNIT_OPTIONS.find((option) => option.value === weightUnits)?.label ?? weightUnits;
  return `${lengthLabel}, ${weightLabel}`;
};

export const UnitsDropdown = ({ buttonClassName }: { buttonClassName?: string }) => {
  const options = useAppSelector(selectOptions);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={s.unitsWrapper}>
      <Button variant={BUTTON_VARIANT.TERTIARY} className={buttonClassName} onClick={() => setIsOpen(true)}>
        {buttonLabel(options.lengthUnits, options.weightUnits)} <AngleDown className={s.icon} />
      </Button>
      <UnitsSettingsModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};
